module.exports = __webpack_public_path__ + "d945d6a3a41a5402e2b00f3070929d79.svg";